import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../api/Api";

httpClient.defaults.headers.common["Authorization"] = "Bearer " + "ey2sakxhakskxnalwoeu297dhs9dsxnx9s0";

const initialState = {
  bookings: [],
  golfCoursesList: [],
  filteredGolfCourses: [],
  originalCourses: [],
  options: [],
  showHistory: false,
};

export const fetchBookingList = createAsyncThunk("team/playerListLoading", () =>
  httpClient
    .get(`/booking/bookings`)
    .then(({ data }) => {
      return data.response;
    })
    .catch(error => error)
);

export const fetchGolfCoursesList = createAsyncThunk("team/membersLoading", () => {
  httpClient.defaults.headers.common["Authorization"] = "Bearer " + "ey2sakxhakskxnalwoeu297dhs9dsxnx9s0";

  httpClient
    .get(`/members/`)
    .then(({ data }) => {
      //console.log({ data });
      return data.response;
    })
    .catch(error => error);
});

export const bookings = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setBookingsList: (state, action) => {
      state.bookings = action.payload;
    },
    setGolfCoursesList: (state, action) => {
      state.golfCoursesList = action.payload;
    },
    setFilteredGolfCoursesList: (state, action) => {
      state.filteredGolfCourses = action.payload;
    },
    setOriginalGolfCoursesList: (state, action) => {
      state.originalCourses = action.payload;
    },
    setoptions: (state, action) => {
      state.options = action.payload;
    },
    setShowHistory: (state, action) => {
      state.showHistory = action.payload;
    },
    decrement: state => {
      //   state.value -= 1
    },
    incrementByAmount: (state, action) => {
      // console.log("payload:", action.payload);
      //   state.value += action.payload
    },
  },
  extraReducers: {
    [fetchBookingList.pending.type]: (state, action) => {
      state.bookings = {
        status: "loading",
        data: {},
        error: {},
      };
    },
    [fetchBookingList.fulfilled.type]: (state, action) => {
      state.bookings = {
        status: "idle",
        data: action.payload,
        error: {},
      };
    },
    [fetchBookingList.rejected.type]: (state, action) => {
      state.bookings = {
        status: "idle",
        data: {},
        error: action.payload,
      };
    },

    // [fetchGolfCoursesList.pending.type]: (state, action) => {
    //   state.golfCoursesList = {
    //     status: "loading",
    //     data: {},
    //     error: {},
    //   };
    // },
    // [fetchGolfCoursesList.fulfilled.type]: (state, action) => {
    //   state.golfCoursesList = {
    //     status: "idle",
    //     data: action.payload,
    //     error: {},
    //   };
    // },
    // [fetchGolfCoursesList.rejected.type]: (state, action) => {
    //   state.golfCoursesList = {
    //     status: "idle",
    //     data: {},
    //     error: action.payload,
    //   };
    // },
  },
});

// Action creators are generated for each case reducer function
export const {
  setBookingsList,
  decrement,
  incrementByAmount,
  setOriginalGolfCoursesList,
  setGolfCoursesList,
  setoptions,
  setFilteredGolfCoursesList,
  setShowHistory,
  // originalCourses,
  golfCoursesList,
} = bookings.actions;

export default bookings.reducer;
